import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import EditReasonReturnModal from '../../../../views/order/common/modal/EditReturnReasonModal';
import { orderActions } from '../../../../store/modules/order';
import { ORDER_RETURN_ITEM_TYPE } from '../../../../constants/service/app/orderConstants';
import withModal from '../../../../lib/hoc/withModal';

class EditReturnReasonModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  반품 사유타입
       */
      reasonType: ORDER_RETURN_ITEM_TYPE.ORDER_MISTAKE,
      /**
       *  반품 상세사유
       */
      reason: null,
    };
  }

  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'editReasonReturnModal',
    });
  };

  /**
   * 반품 사유 수정하기
   */
  onSubmit = () => {
    const { form, data, editOrderReturnReason } = this.props;
    const { orderItemInfo } = data;
    const { reasonType, reason } = this.state;

    form.validateFields((err) => {
      if (err) return;

      editOrderReturnReason({
        orderItemId: orderItemInfo.orderItemId,
        reasonType,
        reason,
      });

      this.closeModal();
    });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  render() {
    const { form, isOpen, data } = this.props;

    return (
      <EditReasonReturnModal
        {...this.state}
        form={form}
        isOpen={isOpen}
        data={data}
        closeModal={this.closeModal}
        onSubmit={this.onSubmit}
        setData={this.setData}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.editReasonReturnModal.isOpen,
    data: state.order.editReasonReturnModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  editOrderReturnReason: orderActions.editOrderReturnReason,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(Form.create({})(EditReturnReasonModalContainer)));
